import { isPendingAssistantText } from '@/constants/chat'
import { AgentReplyPreamble } from '@/components/Chat/AgentReplyPreamble'

/** @typedef {import('./chatThreadTypes.js').ChatMessage} ChatMessage */

/**
 * @param {{
 *   assistant: ChatMessage,
 *   expanded: boolean,
 *   onToggleExpand: (() => void) | null,
 * }} props
 */
export default function ChatThreadAssistantPreamble({ assistant, expanded, onToggleExpand }) {
  const workflowSteps = assistant.workflowTrace?.steps ?? []
  const hasWorkflow = Array.isArray(workflowSteps) && workflowSteps.length > 0
  const usesUnifiedTimeline = Boolean(assistant.phase1RunId)

  if (usesUnifiedTimeline && !hasWorkflow) return null

  const thoughtDetails = Array.isArray(assistant.thoughtDetails)
    ? assistant.thoughtDetails.filter((s) => typeof s === 'string')
    : []
  const thoughtStreaming = Boolean(
    assistant.demoStreamActive &&
      !(Array.isArray(assistant.blocks) && assistant.blocks.length > 0),
  )

  return (
    <AgentReplyPreamble
      agentBrand={assistant.agentBrand ?? 'SIA'}
      agentName={assistant.agentName ?? 'Master Root Agent'}
      thoughtSummary={
        usesUnifiedTimeline
          ? null
          : assistant.thoughtSummary ??
            (isPendingAssistantText(assistant.text) ? 'Thinking…' : null)
      }
      thoughtDetails={usesUnifiedTimeline ? [] : thoughtDetails}
      thoughtStreaming={thoughtStreaming}
      workflowTrace={assistant.workflowTrace ?? null}
      expanded={expanded}
      onToggleExpand={onToggleExpand}
    />
  )
}
